import { FC } from 'react';
import { ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

interface SimpleMenuItemProps {
    label: string;
    icon: React.ReactNode;
    isActive: boolean;
    onClick: () => void;
}

export const SimpleMenuItem: FC<SimpleMenuItemProps> = ({
    label,
    icon,
    isActive,
    onClick,
}) => {
    return (
        <ListItemButton
            onClick={onClick}
            sx={{
                borderRadius: 1,
                mb: 0.5,
                backgroundColor: isActive ? 'primary.light' : 'transparent',
                '&:hover': {
                    backgroundColor: isActive ? 'primary.light' : 'action.hover',
                },
            }}
        >
            <ListItemIcon
                sx={{
                    color: isActive ? 'primary.main' : 'text.secondary',
                    minWidth: 40,
                }}
            >
                {icon}
            </ListItemIcon>
            <ListItemText
                primary={label}
                sx={{
                    '& .MuiListItemText-primary': {
                        fontWeight: isActive ? 600 : 400,
                    },
                }}
            />
        </ListItemButton>
    );
};
